import React, { Fragment, useEffect, useState } from "react";
import {
  Typography,
  Container,
  Grid,
  InputLabel,
  Select,
  Input,
  MenuItem,
  TextField,
  Button,
  TableContainer,
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  Checkbox,
  useTheme,
  Stack,
} from "@mui/material";
import { makeStyles } from "@mui/styles";

import { Link } from "react-router-dom/cjs/react-router-dom";

import InfiniteTable from "../../../components/InfiniteTable/InfiniteTable";

const useStyles = makeStyles((theme) => ({
  textField: {
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1),
    width: 200,
  },
  paper: {
    marginTop: theme.spacing(5),
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  },
}));

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};

const ReceiptPreview = (props) => {
  const {
    receiptData,
    receiptName,
    warehouses,
    warehousesSelected,
    receiptId,
    handleChangeReceiptDataMapped,
    handleChangeReceiptName,
    handleChangeWarehouses,
    toggleConfirmModal,
  } = props;
  const theme = useTheme();
  const classes = useStyles();

  const [columns, setColumns] = useState([]);
  const [columnsExposed, setColumnsExposed] = useState([]);
  const [data, setData] = useState([]);
  const [invalidData, setInvalidData] = useState([]);
  const [columnsMapped, setColumnsMapped] = useState([]);
  const [dataMapped, setDataMapped] = useState([]);
  const [mapByColumn, setMapByColumn] = useState("index");

  const handleChange = (e) => {
    const { checked, name, value } = e.target;
    const [columnId, rowId] = name.split("-");

    /*if (value.includes("_custom_substitution_")) {
    setSubstitutionSettings((prevState) => ({
      ...prevState,
      order_id: orderItems[rowId].order,
      original_product: orderItems[rowId],
    }));
    toggleProductModal();
  } else {*/
    const columnData = columnsExposed.find((item) => item.id === columnId);
    if (columnData.exposed) {
      setInvalidData((prevState) =>
        prevState.map((item, index) => {
          if (+rowId === index) {
            const columnValue = columnData.hasOwnProperty("exposedAs")
              ? columnData.exposedAs === "checkbox"
                ? checked
                : value
              : value;
            item[columnId] = columnValue;

            return item;
          } else {
            return item;
          }
        })
      );
    }
    // }
  };

  const handleReValidate = () => {
    setDataMapped([...data, ...invalidData]);
  };

  useEffect(() => {
    if (receiptData.length > 0) {
      const headersIndex = receiptData.findIndex((item) =>
        ["line", "upc"].includes(String(item[0]).toLowerCase())
      );

      const receiptHeaders =
        headersIndex === -1
          ? Object.keys(receiptData[0])
          : receiptData[headersIndex];
      const receiptDataColumn = receiptHeaders.map((item) => ({
        id: item,
        label: item,
      }));

      const receiptDataData = receiptData.filter(
        (item, index) => index > headersIndex
      );

      setColumns(receiptDataColumn);
      setData(receiptDataData);
      setColumnsMapped(receiptDataColumn);
      setDataMapped(receiptDataData);
    }
  }, [receiptData]);

  useEffect(() => {
    const validateData = () => {
      if (warehousesSelected !== "") {
        let warehouse = warehouses.find(
          (item) => item.id === warehousesSelected
        );

        const warehouseMapping =
          typeof warehouse.csv_header_mapping === "string"
            ? JSON.parse(warehouse.csv_header_mapping)
            : warehouse.csv_header_mapping;

        let dbColumnIndexing = [];
        let dbColumns = [];
        let dbColumnsExposed = [];
        Object.keys(warehouseMapping).forEach((item) => {
          let receiptDataColumnIndex = columnsMapped.findIndex(
            (column, index) => item === column.id
          );

          if (item === "Ext. Value" && receiptDataColumnIndex === -1) {
            receiptDataColumnIndex = columnsMapped.findIndex(
              (column, index) => "Total" === column.id
            );
          }

          dbColumnIndexing[warehouseMapping[item]] = Array.isArray(
            dbColumnIndexing[warehouseMapping[item]]
          )
            ? [].concat(
                ...dbColumnIndexing[warehouseMapping[item]],
                receiptDataColumnIndex
              )
            : [receiptDataColumnIndex];

          if (!dbColumns.includes(warehouseMapping[item])) {
            dbColumns.push(warehouseMapping[item]);
          }
        });

        let dbColumnsValidData = [];
        let dbColumnsInvalidData = [];
        dataMapped.forEach((row) => {
          let rowObj = {
            quantity: 0,
            unit_type: "",
            total: 0,
            product: null,
          };
          let rowValid = true;
          dbColumns.forEach((item) => {
            const indexingValues = Array.isArray(row)
              ? dbColumnIndexing[item]
              : item;
            if (Array.isArray(indexingValues) && indexingValues.length > 1) {
              const numValues = indexingValues.every(
                (val) => !isNaN(+row[val])
              );
              rowObj[item] = numValues
                ? indexingValues.reduce(
                    (value, current) => value + +row[current],
                    0
                  )
                : indexingValues.reduce(
                    (value, current) =>
                      isNaN(value)
                        ? value + " " + row[current]
                        : value + (isNaN(+row[current]) ? 0 : +row[current]),
                    isNaN(rowObj[item]) ? "" : 0
                  );
            } else {
              if (item.includes("unit_type")) {
                if (row[indexingValues] !== "") {
                  if (["U", "C"].includes(row[indexingValues])) {
                    rowObj[item] = row[indexingValues];
                  } else {
                    rowValid = false;
                  }
                } else {
                  rowValid = false;
                }
              } else if (item === "total" || item === "quantity") {
                if (
                  row[indexingValues] === "" ||
                  row[indexingValues] === null ||
                  Number.isNaN(+row[indexingValues])
                ) {
                  rowValid = false;
                } else {
                  if (typeof row[indexingValues] === "string") {
                    const numberArray = row[indexingValues].split(",");
                    if (numberArray.length > 1) {
                      const decimals = numberArray.pop();
                      rowObj[item] = parseFloat(
                        numberArray.join("") + "." + decimals
                      );
                    } else {
                      rowObj[item] = +row[indexingValues];
                    }
                  } else {
                    rowObj[item] = row[indexingValues];
                  }
                }
              } else if (item === "product") {
                if (row[indexingValues] === "") {
                  rowValid = false;
                } else {
                  rowObj[item] = row[indexingValues];
                }
              } else {
                if (row[indexingValues] === "") {
                  rowObj[item] = 0;
                } else {
                  rowObj[item] = row[indexingValues];
                }
              }
            }
          });

          const indexingValue = Array.isArray(row)
            ? dbColumnIndexing["product"]
            : "product";

          if (
            row[indexingValue] &&
            String(row[indexingValue]).includes("Surcharge:")
          ) {
            rowObj["product"] = String(row[indexingValue]).replace(
              "Surcharge:",
              ""
            );
            rowObj["unit_type"] = "U";
            rowValid = true;
          } else if (
            row[indexingValue] &&
            String(row[indexingValue]).includes("Surcharge Void:")
          ) {
            rowObj["product"] = String(row[indexingValue]).replace(
              "Surcharge Void:",
              ""
            );
            rowObj["unit_type"] = "U";
            rowValid = true;
          } else if (
            row[indexingValue] &&
            String(row[indexingValue]).includes("Void:")
          ) {
            rowObj["product"] = String(row[indexingValue]).replace("Void:", "");
            rowObj["unit_type"] = null;
            rowValid = true;
          }

          if (rowValid) {
            dbColumnsValidData.push(rowObj);
          } else {
            dbColumnsInvalidData.push(rowObj);
          }
        });

        dbColumns = dbColumns.map((item) => ({
          id: item,
          label: item,
        }));

        dbColumnsExposed = dbColumns.map((item) => ({
          ...item,
          exposed: true,
          exposedAs: item.id === "unit_type" ? "select" : "input",
        }));

        setColumns(dbColumns);
        setColumnsExposed(dbColumnsExposed);
        setData(dbColumnsValidData);
        setInvalidData(dbColumnsInvalidData);
        setMapByColumn("id");
      }
    };

    validateData();
  }, [dataMapped, columnsMapped, warehouses, warehousesSelected]);

  useEffect(() => {
    handleChangeReceiptDataMapped(data);
  }, [data, handleChangeReceiptDataMapped]);

  return (
    <div className={classes.paper}>
      <Grid container spacing={2}>
        <Grid item xs={12} sm={12}>
          <Typography component="h6" variant="h6" align="center">
            Receipt Preview
          </Typography>
        </Grid>
        <Grid item xs={12} sm={12}>
          <Typography component="h4" style={{ textAlign: "center" }}>
            Select the warehouse to map receipt information correctly.
          </Typography>
        </Grid>
        <Grid item xs={12} sm={12}>
          <Container>
            <Grid container spacing={2} alignItems="center">
              <Grid item xs={12} sm={4}>
                <InputLabel>Warehouses</InputLabel>
                <Select
                  fullWidth
                  label="Warehouses"
                  onChange={handleChangeWarehouses}
                  name="warehouses"
                  input={<Input />}
                  value={warehousesSelected}
                  MenuProps={MenuProps}
                  disabled={receiptId !== null}
                >
                  <MenuItem value="">
                    <em>- None -</em>
                  </MenuItem>
                  {warehouses.map((option) => (
                    <MenuItem key={"warehouse" + option.id} value={option.id}>
                      {option.name}
                    </MenuItem>
                  ))}
                </Select>
              </Grid>
              <Grid item xs={12} sm={4}>
                <TextField
                  fullWidth
                  size="small"
                  variant="outlined"
                  label="Receipt Name"
                  name="receipt_name"
                  value={receiptName}
                  onChange={handleChangeReceiptName}
                />
              </Grid>
            </Grid>
          </Container>
        </Grid>
        <Grid item xs={12} sm={12}>
          {warehousesSelected !== "" ? (
            <Container>
              <InfiniteTable
                {...props}
                apiep={null}
                columns={columns}
                data={data}
                dataMapByColumn={mapByColumn}
                deletable={false}
                editable={null}
                filterable={true}
                label="Receipt information"
                fetchingModal={null}
              />
            </Container>
          ) : (
            <></>
          )}
        </Grid>
        <Grid item xs={12} sm={12}>
          {invalidData.length > 0 ? (
            <Container>
              <div
                style={{ textAlign: "right", marginBottom: theme.spacing(3) }}
              >
                <Button
                  color="success"
                  disabled={warehousesSelected === ""}
                  variant="contained"
                  onClick={() => handleReValidate()}
                >
                  Re-validate
                </Button>
              </div>
              {/* <InfiniteTable
                {...props}
                apiep={null}
                columns={columnsExposed}
                data={invalidData}
                dataMapByColumn={mapByColumn}
                deletable={false}
                editable={null}
                filterable={true}
                label="Invalid Receipt Information"
                fetchingModal={null}
              /> */}
              <TableContainer sx={{ maxHeight: 600 }}>
                <Table stickyHeader aria-label="sticky table">
                  <TableHead>
                    <TableRow>
                      {columnsExposed.map((column) => (
                        <TableCell
                          key={`header-${column.id}`}
                          align={column.align}
                          style={{ minWidth: column.minWidth }}
                        >
                          {column.label}
                        </TableCell>
                      ))}
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {/* .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage) */}
                    {invalidData.map((row, index) => (
                      <TableRow hover tabIndex={-1} key={`row ${index}`}>
                        {columnsExposed.map((column) => {
                          const value = row[column.id];
                          return (
                            <TableCell key={`column-${column.id}-row-${index}`}>
                              {column.exposed
                                ? {
                                    input: (
                                      <Input
                                        name={`${column.id}-${index}`}
                                        value={value || ""}
                                        onChange={handleChange}
                                        disabled={
                                          (column.id === "unit_quantity" &&
                                            row.display_unit_price <= 0) ||
                                          (column.id === "case_quantity" &&
                                            row.display_case_price <= 0)
                                        }
                                      />
                                    ),
                                    checkbox: (
                                      <Checkbox
                                        name={`${column.id}-${index}`}
                                        value={value}
                                        checked={!!value}
                                        onChange={handleChange}
                                        disabled={column.id === "picked"}
                                      />
                                    ),
                                    select:
                                      value === false ? (
                                        <></>
                                      ) : column.id === "unit_type" ? (
                                        <Select
                                          fullWidth
                                          input={<Input />}
                                          name={`${column.id}-${index}`}
                                          value={value}
                                          onChange={handleChange}
                                        >
                                          <MenuItem value="U">U</MenuItem>
                                          <MenuItem value="C">C</MenuItem>
                                        </Select>
                                      ) : (
                                        <Select
                                          fullWidth
                                          input={<Input />}
                                          name={`${column.id}-${index}`}
                                          value={value}
                                          onChange={handleChange}
                                          MenuProps={MenuProps}
                                        >
                                          <MenuItem value={value}>
                                            {"" + value}
                                          </MenuItem>
                                        </Select>
                                      ),
                                  }[column.exposedAs || "input"]
                                : typeof value === "boolean"
                                ? "" + value
                                : value}
                            </TableCell>
                          );
                        })}
                      </TableRow>
                    ))}
                    {!invalidData.length ? (
                      <TableRow>
                        <TableCell colSpan={columns.length} align="center">
                          There are no items in the selected orders
                        </TableCell>
                      </TableRow>
                    ) : (
                      <></>
                    )}
                  </TableBody>
                </Table>
              </TableContainer>
            </Container>
          ) : (
            <></>
          )}
        </Grid>
        <Grid item xs={12}>
          <Stack direction="row" spacing={1} justifyContent="right">
            <Link
              to="/receiptDifference"
              style={{ textDecoration: "none", color: "black" }}
            >
              <Button color="inherit">Cancel</Button>
            </Link>
            <Button
              variant="contained"
              color="primary"
              onClick={() => toggleConfirmModal()}
              disabled={!warehousesSelected || !data.length}
            >
              Upload Receipt
            </Button>
          </Stack>
        </Grid>
      </Grid>
    </div>
  );
};

export default ReceiptPreview;
